import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { OcaenFreightRateRequest } from "./ocaen-freight-rate-request";

export class OcaenFreightRateResponseModel extends GlobalResponseObject{
    data?:OcaenFreightRateRequest[]
     
    constructor(status:boolean, intelCode:number, internalMessage:string ,data?:OcaenFreightRateRequest[]){
    super(status,intelCode,internalMessage)
    this.status=status
    this.intlCode=intelCode
    this.internalMessage=internalMessage
    this.data=data
    }

}